import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

Swiper.use([Navigation, Pagination, Autoplay]);

// Basic Carousel
var swiper = new Swiper(".basic-slider", {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  },
});

// Basic Carousel
var swiper = new Swiper(".basic-carousel", {
  slidesPerView: 2,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
      navigation: {
        enabled: true,
      },
    },
    992: {
      slidesPerView: 5,
      navigation: {
        enabled: true,
      },
    },
  },
});

// Basic Carousel
var swiper = new Swiper(".hero-slider", {
  loop: true,
  autoplay: {
    delay: 7000,
    pauseOnMouseEnter: true,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  },
});
